// extracted by mini-css-extract-plugin
export default {"modalOverlay":"uD-z","modalContent":"vD-z","header":"wD-z","close":"xD-z"};